import aemAxiosClient from '../common/http/http-aem';
import snsAxiosClient from '../common/http/http-sns';

function getLeftNavItems(url) {
  return aemAxiosClient().get(url);
}

export const getProfileInfo = (environmentVariables, user) => {
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_GET_V4,
      accept: 'application/vnd.safeway.v4+json',
      Authorization: `Bearer ${user.authToken}`,
    },
  };
  return snsAxiosClient(options).get(`${environmentVariables.UCA_BASE_API}${user.UUID}/profile?fl=address,factors`);
};

export default getLeftNavItems;
